import * as actionType from 'actions';

export const getJobDetailsLocal = () => ({
    type: actionType.GET_JOB_DETAILS_LOCAL,
});

export const getJobDetailsPost = (jobInfo, key) => ({
    type: actionType.GET_JOB_DETAILS,
    payload: jobInfo,
    key: key,
});

export const getJobDetailsPostSuccess = (jobStatus) => ({
    type: actionType.GET_JOB_DETAILS_SUCCESS,
    payload: jobStatus
});

export const getExistingUser = (data) => ({
    type: actionType.GET_EXISTING_USER,
    payload: data,
});

export const getExistingUserSuccess = (data) => ({
    type: actionType.GET_EXISTING_USER_SUCCESS,
    payload: data
});

export const getAllAplicationsForApplicantPost = (data, key) => ({
    type: actionType.GET_ALL_APPLICATIONS_FOR_APPLICANT_POST,
    payload: data,
    key: key
});

export const getAllAplicationsForApplicantSuccess = data => ({
    type: actionType.GET_ALL_APPLICATIONS_FOR_APPLICANT_SUCCESS,
    payload: data
});

export const getPublicTokenPost = () => ({
    type: actionType.GET_PUBLIC_TOKEN_POST,
});

export const getPublicTokenPostSuccess = (data) => ({
    type: actionType.GET_PUBLIC_TOKEN_POST_SUCCESS,
    payload: data
});